// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"a9a2c7d9","349":"17f3ec20","409":"2cda82b4","443":"2cda82b4","479":"9b2bf81f","605":"397a0438","961":"19277c5f"}[chunkId] + ".chunk.css";
};